import React from "react"

import PartyImg from "@shared/assets/images/img_party.png"
import { useAccount } from "@shared/contexts"

import { URL, WOW_MONEY_MAX_PRICE } from "live/constants"

const Complete = () => {
  const {
    account: { viewer },
  } = useAccount()

  return (
    <div className="coinCont coinComplete">
      <img src={PartyImg} alt="" />
      <div className="coinTxt">
        <strong>
          <span>{viewer?.username}님</span>{" "}
          <span className="colorOrange">미션성공!</span>
        </strong>
        <span>이번달 와우머니</span>
        <strong>
          <em className="colorOrange">
            총 {WOW_MONEY_MAX_PRICE.toLocaleString()}원
          </em>{" "}
          적립 성공
        </strong>
        <p>다음달도 꼭 도전하세요!</p>
      </div>
      <a
        href={URL.MY_WOW_MONEY}
        className="coinLink"
        target="_blank"
        rel="noopener noreferrer"
        title="적립금 보기"
      >
        적립금 보기
      </a>
    </div>
  )
}

export default Complete
